import * as React from "react";
import {imageBaseUrl} from "config";
import "IncompleteInfoV2/BankStatementV2/BSModes/PdfUpload/UploadedFiles/style.scss";

interface IProps {
    files: string[];
}

const UploadedFiles = (props: IProps) => {
    return (
        <div className="bs-upload-list-container">
            {
            props.files && props.files.map((file, index) => {
                return(
                    <div className="upload-list" key={index}>
                        <img src={`${imageBaseUrl}/img/pdf.svg`}/>
                            <div>
                                <p>{`Bank statement ${index + 1}.pdf`}
                                    <span>&nbsp;<i className="fa fa-check-circle"/></span>
                                </p>
                                <p>Uploaded successfully</p>
                            </div>
                    </div>);
                })
            }
         </div>
    );
};

export default UploadedFiles;
